import React from 'react';

interface TeamMember {
  name: string;
  role: string;
  image: string;
  teamShape?: string;
  socialLinks?: {
    facebook: string;
    twitter: string;
    youtube: string;
    linkedin: string;
  };
  detailsLink?: string;
}

interface KidsaTeamProps {
  subtitle: string[];
  title: string[];
  teamMembers: TeamMember[];
}

const KidsaTeam: React.FC<KidsaTeamProps> = ({
  title,
  subtitle,
  teamMembers
}) => {
  return (
    <section className="team-section fix section-bg section-padding" id="profes">
      <div className="top-shape">
        <img src="/assets/kidsa/assets/img/section-top-shape.png" alt="shape-img" />
      </div>
      <div className="love-shape float-bob-x">
        <img src="/assets/kidsa/assets/img/team/love.png" alt="shape-img" />
      </div>
      <div className="frame-shape">
        <img src="/assets/kidsa/assets/img/team/frame.png" alt="shape-img" />
      </div>
      <div className="container">
        <div className="section-title-area">
          <div className="section-title mt-60">
            <span className="wow fadeInUp">{Array.isArray(subtitle) ? subtitle[0] : subtitle}</span>
            <h2 className="wow fadeInUp" data-wow-delay=".3s">{Array.isArray(title) ? title[0] : title}</h2>
          </div>
          <div className="array-button wow fadeInUp" data-wow-delay=".5s">
            <button className="array-prev"><i className="fal fa-arrow-left"></i></button>
            <button className="array-next"><i className="fal fa-arrow-right"></i></button>
          </div>
        </div>
        <div className="swiper team-slider">
          <div className="swiper-wrapper">
            {teamMembers.map((member, index) => (
              <div key={index} className="swiper-slide">
                <div className="team-items">
                  <div className="team-image">
                    <div className="shape-img">
                      <img 
                        src={member.teamShape} 
                        alt="img" 
                      />
                    </div>
                    <img src={member.image} alt="team-img" />
                    {/*<div className="social-profile">
                      <span className="plus-btn"><i className="fas fa-share-alt"></i></span>
                      <ul>
                        {member.socialLinks?.map((social, socialIndex) => (
                          <li key={socialIndex}>
                            <a href={social.url}>
                              <i className={`fab fa-${social.platform}`}></i>
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>*/}
                  </div>
                  <div className="team-content text-center">
                    <h3>
                      <a href={member.detailsLink || "#"}>{member.name}</a>
                    </h3>
                    <p>{member.role}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default KidsaTeam;